import { useState } from "react";
import { Users } from "../../interfaces/UserInterface";
import { ListaPlanesAuditoriasInternas } from "./ListaPlanesAuditoriasInternas"
import { PlanAI } from "../../interfaces/PlanesInterface";
import { PlanAuditoriaInterna } from "./PlanAI";
import { UsuarioSinPrivilegios } from "../login/Alerts";


export const PlanesAuditoriasInternas = ()=>{

    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;
    let permisos = false;

    if(user){
        if(user.Auditoria !== "0"){
            permisos = true;
        }
        if(user.Informes !== "0"){
            permisos = true;
        }
    }

    const [planAuditoria, setPlanAuditoria] = useState<PlanAI>();
    const [update, setUpdate] = useState(false);

    return(
    <>
        {
            permisos?
            <div
                className="row justify-content-center align-items-start g-2"
            >
                <div className="col-2 ocultar-al-imprimir">
                    <ListaPlanesAuditoriasInternas planSelect={planAuditoria} setPlanSelect={setPlanAuditoria} update={update}/>
                </div>
                <div className="col-10">
                    {
                        planAuditoria?
                        <PlanAuditoriaInterna plan={planAuditoria} update={update} setUpdate={setUpdate} setSelectPlan={setPlanAuditoria}/>
                        :
                        <div></div>
                    }
                </div>
            </div>
            :
            <UsuarioSinPrivilegios/>
            
        }
        
    </>
    )
}